import React from 'react';
import { useToast } from '../../context/ToastContext';
import Toast from './Toast';

const ToastContainer: React.FC = () => {
  const { toasts } = useToast();

  if (toasts.length === 0) {
    return null;
  }
  return (
    <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 space-y-3 pointer-events-none">
      {toasts.map((toast, index) => (
        <div
          key={toast.id}
          className="pointer-events-auto"
          style={{
            transform: `translateY(${index * 4}px) scale(${1 - index * 0.02})`,
            zIndex: 50 - index,
            opacity: 1 - index * 0.1
          }}
        >
          <Toast
            id={toast.id}
            message={toast.message}
            type={toast.type}
          />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
